import axios from 'axios';

export const loginIndividualDemoLinkAccount = (key) =>
  axios.post(`${process.env.REACT_APP_OAUTH_URL}/demo/key`, {
    key,
  });
